import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ProjectSendToGas = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        onClick={async () => {
            const { onSendGasProjectToGas } = mainProps
            if(window.confirm("از تسویه حساب اطمینان دارید؟")){
                await onSendGasProjectToGas(rowData.fileNumber)
            }
           
        }}
        disabled={!rowData.isOk}
      >{rowData.solarDateExecutorSubmit ?` تسویه: 
      ${rowData.solarDateExecutorSubmit} -
      پرونده:1001${rowData.fileNumber}` 
      : 'تسویه حساب'}
        
      </Button>
    </Box>
  )
}

export default ProjectSendToGas
